import { createBrowserHistory, createMemoryHistory } from 'history';

export default __CLIENT__ ? createBrowserHistory() : createMemoryHistory();
